
export class ImportoIntervento{
    id:number;
    anno:number;
    importo:number;    
}